import React from 'react';

const GradientTest: React.FC = () => {
  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Teste de Gradientes</h1>
        
        {/* Teste de gradientes em textos */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Gradientes em Textos</h2>
          
          <div className="space-y-4">
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Título com gradiente: 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-secondary-600">
                  {' '}NEIA
                </span>
              </h3>
              <p className="text-gray-600">Este texto deve ter gradiente verde → vermelho</p>
            </div>
            
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Outro título: 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-500 to-secondary-500">
                  {' '}Imigração
                </span>
              </h3>
              <p className="text-gray-600">Este texto deve ter gradiente verde → vermelho (variação)</p>
            </div>
          </div>
        </div>
        
        {/* Teste de gradientes em backgrounds */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Gradientes em Backgrounds</h2>
          
          <div className="space-y-4">
            <div className="p-6 rounded-lg shadow">
              <div className="bg-gradient-to-r from-primary-500 to-secondary-500 p-4 rounded-lg text-white">
                <h3 className="text-xl font-bold">Background com gradiente</h3>
                <p>Este fundo deve ter gradiente verde → vermelho</p>
              </div>
            </div>
            
            <div className="p-6 rounded-lg shadow">
              <div className="bg-gradient-to-r from-primary-600 to-secondary-600 p-4 rounded-lg text-white">
                <h3 className="text-xl font-bold">Background com gradiente (variação)</h3>
                <p>Este fundo deve ter gradiente verde → vermelho (mais escuro)</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Teste de gradientes em hero sections */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Gradientes em Hero Sections</h2>
          
          <div className="hero-gradient p-8 rounded-lg shadow">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Hero Section com gradiente sutil
            </h3>
            <p className="text-gray-600">
              Este fundo deve ter um gradiente sutil de verde claro → branco → vermelho claro
            </p>
          </div>
        </div>
        
        {/* Teste de cores dinâmicas */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Cores Dinâmicas</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-primary-100 p-4 rounded-lg text-center">
              <div className="text-primary-800 font-bold">Primary 100</div>
            </div>
            <div className="bg-primary-500 p-4 rounded-lg text-center text-white">
              <div className="font-bold">Primary 500</div>
            </div>
            <div className="bg-secondary-100 p-4 rounded-lg text-center">
              <div className="text-secondary-800 font-bold">Secondary 100</div>
            </div>
            <div className="bg-secondary-500 p-4 rounded-lg text-center text-white">
              <div className="font-bold">Secondary 500</div>
            </div>
          </div>
        </div>
        
        {/* Debug de variáveis CSS */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Debug de Variáveis CSS</h2>
          
          <div className="bg-gray-900 text-green-400 p-4 rounded-lg font-mono text-sm">
            <div>--primary-500: <span id="primary-500-value">Carregando...</span></div>
            <div>--secondary-500: <span id="secondary-500-value">Carregando...</span></div>
            <div>--primary-600: <span id="primary-600-value">Carregando...</span></div>
            <div>--secondary-600: <span id="secondary-600-value">Carregando...</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientTest;
